const $inject = [];
const lbaLatLongMapSearch = function () {
  return {
    restrict: 'A',
    scope: {
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaLatLongMapSearchCtrl',
    controllerAs: 'vm',
    template: require('./lbaLatLongMapSearch.html')
  }
};

lbaLatLongMapSearch.$inject = $inject;

export default lbaLatLongMapSearch;



// WEBPACK FOOTER //
// ./src/components/lbaLatLongMapSearch/lbaLatLongMapSearchDir.js